import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import HomeworkInfo from '@/components/organisms/Card/Homework/HomeworkInfo'
import HomeworkScore, { GradingResultSummary } from '@/components/organisms/Card/Homework/HomeworkScore'
import { studentHomeworkApi } from 'services/api'
import { getSlugPrefix } from '@/utils/slug'

const StudentHomeworkDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const slugPrefix = getSlugPrefix(location.pathname);
  const goHomeworkList = () => {
    const target = slugPrefix ? `${slugPrefix}/homework/list` : '/homework/list';
    navigate(target);
  };

  const scheduleId = searchParams.get('id');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [gradingResult, setGradingResult] = useState<GradingResultSummary | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!scheduleId) {
        console.error('스케줄 ID가 없습니다.');
        setLoading(false);
        return;
      }

      try {
        console.log('숙제 상세 데이터 로드:', scheduleId);
        const response = await studentHomeworkApi.detail(Number(scheduleId));
        
        if (response.success) {
          console.log('숙제 상세 데이터:', response.data);
          setData(response.data);
        } else {
          console.error('데이터 로드 실패:', response.message);
        }
      } catch (error) {
        console.error('숙제 상세 조회 실패:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [scheduleId]);

  if (loading) {
    return (
      <main className='lg:my-10'>
        <div className='flex justify-center items-center h-64'>
          <p>로딩 중...</p>
        </div>
      </main>
    );
  }

  if (!data) {
    return (
      <main className='lg:my-10'>
        <div className='flex justify-center items-center h-64'>
          <p>데이터를 불러올 수 없습니다.</p>
        </div>
      </main>
    );
  }

  return (
    <main className='lg:my-10'>
      <div className='flex flex-col bg-white p-5 rounded-2xl mb-5'>
        <div className='flex justify-between items-center'>
          <h1 className='heading1'>숙제 채점 상세</h1>
        </div>
      </div>
      <div className='flex flex-col lg:gap-10 lg:flex-row lg:items-start'>
    {/* 숙제 채점표 */}
      <section className='order-2 p-0 lg:order-1'>
          <div className='flex-1 w-full *:shadow-none border border-gray-100 rounded-2xl bg-white'>
              <HomeworkScore 
                type='score' 
                data={data}
                hideVideoQuiz
                suppressVideoQuizUi
                excludeVideoQuizFromSummary
                onGradingResultChange={setGradingResult}
              />
        </div>
    </section>
    
    <section className='p-5 bg-white card lg:max-w-[500px] order-1 lg:order-2 lg:sticky lg:top-5'>
          <HomeworkInfo 
            type='score' 
            data={data}
            gradingResult={gradingResult}
            onIncompleteClick={goHomeworkList}
          />
    </section>

      </div>
    </main>
  )
}

export default StudentHomeworkDetail